import {
  Heart,
  MapPin,
  GraduationCap,
  Briefcase,
  X,
  Cake,
  Dot,
  User,
} from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { useSelector } from "react-redux";
import { getWithTokenAPI, postWithTokenAPI } from "../util/Api";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";

export function ProfileCard({ profile, onNavigate }) {
  // console.log(profile, "--------profileCard-------");
  const [isInterestsent, setIsInterestSent] = useState(false);
  const [sentInterest, setsentInterest] = useState(false);
  const [listprofileImage, setListProfileImage] = useState([]);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const navigate = useNavigate();
  const userpng = "Images/user.png";
  //FETCH INTERESTS
  useEffect(() => {
    const fetchInterests = async () => {
      if (!id || !token || !profile?.user_id) return;
      try {
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${id}`
        );

        if (sentresponse?.data?.receivers?.length) {
          const receivers = sentresponse.data.receivers;
          const isAlreadySent = receivers.some(
            (item) => item.user_id === profile?.user_id
          );

          setsentInterest(isAlreadySent);
        } else {
          setsentInterest(false);
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
        setsentInterest(false);
      }
    };
    fetchInterests();
  }, [id, token, profile?.user_id]);

  // Add this function to fix image URLs
  const fixImageUrl = (url) => {
    if (!url) return "";
    return url.replace(
      "s3.eu-north-1.amazonaws.com",
      "s3.ap-south-1.amazonaws.com"
    );
  };
  console.log(profile, "PROFILE CARD");
  const capitalize = (str) => {
    if (typeof str !== "string" || !str) return "";
    else if (str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
    else return str.toUpperCase();
  };
  if (!profile) return {};
  return (
    <Card className="overflow-hidden hover:shadow-lg  transition-shadow duration-300 cursor-pointer">
      <div
        className="relative"
        onClick={async () => {
          if (!token) {
            setShowLoginDialog(true);
            return;
          }
          try {
            // onNavigate?.("view-profile", profile.user_id);
            const payload = {
              viewer_id: id,
              viewed_id: profile.user_id,
            };
            const response = await postWithTokenAPI(
              token,
              `/profile-view/track`,
              payload
            );
            if (response?.statusCode === 200) {
              console.log("viewer count updated");
            } else {
              console.log("error in updating viewer count");
            }
          } catch (error) {
            console.error("Error in viewed profile post");
          }
        }}
      >
        {/* <h6>{pro}</h6> */}
        <ImageWithFallback
          src={fixImageUrl(profile.profileImage) || userpng}
          alt={profile.name}
          className="w-full h-64 object-cover"
          style={{ objectPosition: "top", backgroundColor: "#FEF9C3" }}
        />
        {/* <img src={listprofileImage || "#" }/> */}
        <div className="absolute top-4 right-4 flex gap-2">
          {/* <Button
            size="sm"
            variant="secondary"
            className="w-9 h-4 flex items-center justify-center p-0"
          >
            <div
              className={
                profile.status === "Active"
                  ? "w-8 h-3 bg-green-500"
                  : "w-8 h-3 bg-red-500"
              }
            />
          </Button> */}


          {/* <Button
            size="sm"
            className="rounded-full w-10 h-10 p-0 bg-red-500 hover:bg-red-600"
          >
            <Heart className="h-4 w-4" />
          </Button> */}
        </div>

        {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
          <h3 className="text-white text-xl mb-1">
            {profile.name}, {profile.age}
          </h3>
          <div className="flex items-center text-white/90 text-sm">
            <MapPin className="h-4 w-4 mr-1" />
            {profile.location || profile.district}
          </div>
        </div> */}
      </div>

      <CardContent className="p-4">
        <div className="space-y-3">
          <div className="flex items-center text-m text-muted-foreground cursor-pointer">
            {/* <GraduationCap className="h-6 w-6 mr-2" style={{marginBottom:"5px"}}/> */}
            <img
              src="./Images/user.png"
              className="h-5 w-5 mr-2"
              style={{ marginBottom: "10px" }}
            ></img>
            <h4
              className="text-primary text-2xl mb-1 font-bold"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {profile.name}
            </h4>
          </div>

          <div className="flex items-center text-m text-muted-foreground">
            <Cake
              className="h-5 w-5 mr-2"
              style={{ marginBottom: "10px" }}
            ></Cake>
            <h4
              className="text-primary text-l mb-1"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {profile.age} y
            </h4>

          </div>

          <div className="flex items-center  text-m text-muted-foreground">
            {/* <span className="text-muted-foregmargin"
            /> */}
            <MapPin className="h-5 w-5 mr-2 text-red-600" style={{ marginBottom: "5px" }} />
            <h4
              className="text-primary text-l mb-1"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {profile.city?.toLowerCase() === profile.district?.toLowerCase()
                ? capitalize(profile.district)
                : `${capitalize(profile.city)}, ${capitalize(
                  profile.district
                )}`}
            </h4>
            {/* <Badge variant="secondary">{profile.religion}</Badge> */}
          </div>

          {/* <div className="flex flex-wrap gap-1">
            {profile.interests?.slice(0, 3).map((interest, index) => (
              <Badge key={index} variant="outline" className="text-xs">
                {interest}
              </Badge>
            ))}
            {profile.interests?.length > 3 && (
              <Badge variant="outline" className="text-xs">
                +{profile.interests.length - 3} more
              </Badge>
            )}
          </div> */}

          <div className="flex gap-2 pt-2">
            <Button
              className="flex-1 cursor-pointer"
              variant="default"
              size="sm"
              onClick={async () => {
                if (!token) {
                  setShowLoginDialog(true);
                  return;
                }
                try {
                  navigate(`/view-profile/${profile.user_id}`);
                  const payload = {
                    viewer_id: id,
                    viewed_id: profile.user_id,
                  };
                  const response = await postWithTokenAPI(
                    token,
                    `/profile-view/track`,
                    payload
                  );
                  if (response?.statusCode === 200) {
                    console.log("viewer count updated");
                  } else {
                    console.log("error in updating viewer count");
                  }
                } catch (error) {
                  console.error("Error in viewed profile post");
                }
              }}
            >
              View Profile
            </Button>
            {/* <Button
              variant="outline"
              size="sm"
              className={
                isInterestsent
                  ? "flex-1 bg-red-500 hover:bg-red-600 hover:text-white-900 text-white"
                  : "flex-1 bg-white text-black hover:bg-red-50"
              }
              onClick={async () => {
                try {
                  const payload = {
                    from_user_id: id,
                    to_user_id: profile?.user_id,
                  };
                  console.log("Payload for interest", payload);
                  const response = await postWithTokenAPI(
                    token,
                    `/interest/create`,
                    payload
                  );

                  if (response?.statusCode === 200) {
                    setIsInterestSent(true);
                  }
                } catch (error) {
                  console.log("error in sending Interest");
                }
              }}
            >
              {isInterestsent ? "Interest Sent" : "Send Interest"}
            </Button> */}
            <Button
              variant="default"
              size="sm" // ✅ Prevent re-click
              className="flex-1 text-white cursor-pointer"
              style={{ background: 'linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))' }}
              onClick={token ? async () => {
                if (isInterestsent || sentInterest) return; // ✅ Safety check
                try {
                  const payload = {
                    from_user_id: id,
                    to_user_id:
                      profile?.user_id || profile?.basicProfile?.user_id,
                  };

                  const response = await postWithTokenAPI(
                    token,
                    `/interest/create`,
                    payload
                  );

                  if (response?.statusCode === 200) {
                    setIsInterestSent(true);
                    toast.success("Interest Sent Successfully")
                  }
                } catch (error) {
                  console.error("❌ Error sending Interest:", error);
                  toast.error("Interest Sent UnSuccessfully")
                }
              }
                : () => { setShowLoginDialog(true) }}
              disabled={isInterestsent || sentInterest}
            >
              {isInterestsent || sentInterest
                ? "Interest Sent"
                : "Send Interest"}

            </Button>
          </div>
        </div>
      </CardContent>
      <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>You’re Almost There!</AlertDialogTitle>
            <AlertDialogDescription>Log in to explore profiles and start connecting</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowLoginDialog(false)}
              className="cursor-pointer"
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-red-500 to-red-700 hover:from-red-600 hover:to-red-800 text-white cursor-pointer"
              onClick={() => {
                setShowLoginDialog(false);
                navigate('/login'); // 👈 navigate to login screen
              }}
            >
              Login
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Card>
  );
}
